import { render, staticRenderFns } from "./HomeWatermark.vue?vue&type=template&id=72f6cff7&"
import script from "./HomeWatermark.vue?vue&type=script&lang=js&"
export * from "./HomeWatermark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports